import script from "./view.vue?vue&type=script&lang=js&setup=true"
export * from "./view.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__